import React, { useState, useEffect } from "react";
import styles from "../../../styles.module.scss";
import { List, Row, Col } from "antd-latest";
import { Checkbox } from "antd";
import { Flex } from "@components/ui/Flex";
import { isEqual } from "lodash";

interface SelectedTagEditProps {
    selectedTags: string[];
    setFieldValue: (field: string, value: string) => void;
    selectedRowKeys: string[];
}

const SelectedTagEdit: React.FC<SelectedTagEditProps> = ({ selectedTags, setFieldValue, selectedRowKeys }) => {
    const [search, setSearch] = useState("");
    const [checkedList, setCheckedList] = useState<string[]>([]);
    const [editableValues, setEditableValues] = useState<{ [key: string]: string }>({});
    const [prevTags, setPrevTags] = useState<string[]>([]);

    useEffect(() => {
        if (!isEqual(prevTags, selectedRowKeys)) {
            setEditableValues(Object.fromEntries(selectedRowKeys.map((item) => [item, item])));
            setCheckedList(selectedRowKeys);
            setPrevTags(selectedRowKeys);
        }
    }, [selectedRowKeys, prevTags]);

    useEffect(() => {
        const finalValues = checkedList.map((item) => editableValues[item]).join(", ");
        setFieldValue("tags", finalValues);
    }, [checkedList, editableValues, setFieldValue]);

    const filteredItems = selectedRowKeys?.filter((item) =>
        item.toLowerCase().includes(search.toLowerCase())
    );

    const handleCheck = (checked: boolean, item: string) => {
        setCheckedList((prev) =>
            checked ? [...prev, item] : prev.filter((i) => i !== item)
        );
    };

    const handleSelectAll = (checked: boolean) => {
        setCheckedList(checked ? [...selectedRowKeys] : []);
    };

    const handleInputChange = (value: string, item: string) => {
        setEditableValues((prev) => ({ ...prev, [item]: value }));
    };

    const handleReset = () => {
        setPrevTags(selectedRowKeys);
        setCheckedList(selectedRowKeys);
        setEditableValues(Object.fromEntries(selectedRowKeys?.map((item) => [item, item])));
    };

    return (
        <Flex flexDirection={"column"} gap="0px">
            <input
                onChange={(e) => setSearch(e.target.value)}
                width={"200px"}
                className="search_input"
                placeholder="Search..."
                value={search}
            />
            <Flex justifyContent={"space-between"} alignItems={"center"}>
                <Checkbox
                    className={styles["checkbox-tag"]}
                    checked={checkedList.length === selectedRowKeys?.length}
                    indeterminate={checkedList.length > 0 && checkedList.length < selectedRowKeys?.length}
                    onChange={(e) => handleSelectAll(e.target.checked)}

                >
                    Select All
                </Checkbox>
                <button type="button" style={{ marginTop: 8 }} onClick={handleReset} className="btn btn-grey btn-sm">
                    Reset
                </button>
            </Flex>
            <List
                className={styles["tag_checks_container"]}
                dataSource={filteredItems}
                renderItem={(item, index) => {
                    if (index % 2 === 0) {
                        return (
                            <Row gutter={8} >
                                <Col span={12}>
                                    <Flex flexDirection={"row"} gap="10px" alignItems={"center"}>
                                        <Checkbox
                                            className={styles["checkbox-tag"]}
                                            checked={checkedList.includes(filteredItems[index])}
                                            onChange={(e) => handleCheck(e.target.checked, filteredItems[index])}
                                        />
                                        <input
                                            onChange={(e) => handleInputChange(e.target.value, filteredItems[index])}
                                            className={styles["tag_input"]}
                                            disabled={!checkedList.includes(filteredItems[index])}
                                            value={editableValues[filteredItems[index]]}
                                        />
                                    </Flex>
                                </Col>
                                {filteredItems[index + 1] && (
                                    <Col span={12}>
                                        <Flex flexDirection={"row"} gap="10px" alignItems={"center"}>
                                            <Checkbox

                                                className={styles["checkbox-tag"]}
                                                checked={checkedList.includes(filteredItems[index + 1])}
                                                onChange={(e) => handleCheck(e.target.checked, filteredItems[index + 1])}
                                            />
                                            <input
                                                onChange={(e) => handleInputChange(e.target.value, filteredItems[index + 1])}
                                                className={styles["tag_input"]}
                                                disabled={!checkedList.includes(filteredItems[index + 1])}
                                                value={editableValues[filteredItems[index + 1]]}
                                            />
                                        </Flex>
                                    </Col>
                                )}
                            </Row>
                        );
                    }
                    return null;
                }}
            />
        </Flex>
    );
};

export default SelectedTagEdit;
